class MenuToggler {
	/**
	 * Connects a toggle button with a menu.
	 *
	 * @param {HTMLElement|string} menuSelector
	 * @param {HTMLElement[]|string[]} toggleSelectors
	 * @param {HTMLElement[]|string[]} toggleableIcons
	 * @param {string} toggledClassName
	 * @param {string} iconsToggledClassName
	 */
	constructor(menuSelector, toggleSelectors, toggleableIcons, toggledClassName = "hidden", iconsToggledClassName = "hidden") {
		this.menu =
			menuSelector instanceof HTMLElement
				? menuSelector
				: document.querySelector(menuSelector)

		this.toggleButtons = toggleSelectors.map(selector =>
			selector instanceof HTMLElement
				? selector
				: document.querySelector(selector)
		)

		this.toggleIcons = toggleableIcons.map(selector =>
			selector instanceof HTMLElement
				? selector
				: document.querySelector(selector)
		)

		this.toggledClassName = toggledClassName
		this.iconsToggledClassName = iconsToggledClassName

		this.toggleButtons.forEach(button =>
			button.addEventListener("click", this.handler.bind(this))
		)
	}

	handler(event) {
		event.preventDefault()
		this.toggle()
	}

	toggle() {
		this.menu.classList.toggle(this.toggledClassName)
		this.toggleIcons.forEach(icon =>
			icon.classList.toggle(this.iconsToggledClassName)
		)
	}
}

export { MenuToggler }
